/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
import React, { useState, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { Row, Col, Table, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { MdOutlineKeyboardArrowRight } from 'react-icons/md';
import AppSelect from '../../shared/components/app-select/AppSelect';
import AppButton from '../../shared/components/app-button/AppButton';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import AppNumberInput from '../../shared/components/app-number-input/AppNumberInput';
import { acceptReceiptRequest, getUserDetails } from '../../api/profileApi';
import AppLink from '../../shared/components/app-link/AppLink';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import {
  NET_BANKING_OPTIONS,
  NET_BANKING_OPTIONS_LIVE,
  PAYU_BANKING_OPTIONS,
  PAYU_BANKING_OPTIONS_LIVE,
} from '../../shared/constants/NetBankingOptions';
import {
  getUserAgentId,
  getValueFromAppConfig,
} from '../../shared/helper-utils/localStorage';
import { getPaymentGateway } from '../../api/flightApi';
import { isEmpty } from '../../shared/helper-utils/appUtils';
import AccountsPageHorizontalBar from './accounts/AccountsPageHorizontalBar';
import AppCheckBox from '../../shared/components/app-check-box/AppCheckBox';
import { useAppContext } from '../../saas/AppConfigWrapper';

function BalanceUpload() {
  const { appConfig } = useAppContext();
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const navigate = useNavigate();
  const [openConfirmPopup, setOpenConfirmPopup] = useState(false);
  const [validationError, setValidationError] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const [paymentRequest, setPaymentRequest] = useState({
    deposited_amount: '',
    payment_mode: 'creditcard',
    selected_bank: '',
    pgname: '',
  });
  const [totalInvoice, setTotalInvoice] = useState('');
  const [gstOnPgCharges, setGstOnPgCharges] = useState('');
  const urlRef = useRef(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [openStatusPopup, setOpenStatusPopup] = useState(false);
  const [pgCharge, setPgCharge] = useState('');
  const [refTxid, setRefTxId] = useState('');
  const availablePgsRef = useRef([]);
  const [pgOptionsForPaymentMode, setPgOptionsForPaymentMode] = useState([]);
  const [agent, setAgent] = useState({});
  const [isPayuPgAccepted, setIsPayuPgAccepted] = useState(false);

  const getPgsForPaymentMode = async () => {
    setIsLoading(true);
    const response = await getUserDetails(getUserAgentId());
    if (response && response.ApiStatus && response.ApiStatus.Status === 'OK') {
      const { User } = response.ApiStatus.Result;
      if (!isEmpty(User)) {
        setAgent(User);
      }
    }
    const res = await getPaymentGateway(getUserAgentId());
    if (res && res.Root && res.Root.Status === 'OK') {
      if (!isEmpty(res.Root.Result)) {
        const { AvailablePaymentGateways } = res.Root.Result;
        if (!isEmpty(AvailablePaymentGateways)) {
          const { AvailablePaymentGateway } = AvailablePaymentGateways;
          const list = Array.isArray(AvailablePaymentGateway)
            ? AvailablePaymentGateway
            : [AvailablePaymentGateway];
          list.forEach((x) => {
            x.label =
              x.GatewayName === 'techprocessv2' ? 'Worldline' : x.GatewayName;
            x.value = x.GatewayName;
          });
          availablePgsRef.current = list;
          const pgForCreditCard = list.filter(
            (x) => x.PaymentMode.toLowerCase() === 'creditcard',
          );
          if (pgForCreditCard.length > 0) {
            setPaymentRequest((prevState) => ({
              ...prevState,
              pgname: pgForCreditCard[0].GatewayName,
            }));
          }
          setPgOptionsForPaymentMode(pgForCreditCard);
        }
      }
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getPgsForPaymentMode();
  }, []);

  const isAmexNotRequired =
    getValueFromAppConfig('NOTREQURIEDAMEX') === 'true' ||
    getValueFromAppConfig('NOTREQUIREDAMEX') === 'true';

  const PAYMENT_OPTIONS = [
    { label: formattedMessage('credit_card'), value: 'creditcard' },
    { label: formattedMessage('debit_card'), value: 'debitcard' },
    { label: formattedMessage('net_banking'), value: 'netbanking' },
    ...(!isAmexNotRequired
      ? [{ label: formattedMessage('amex'), value: 'amex' }]
      : []),
    { label: formattedMessage('upi'), value: 'upi' },
  ];
  const isNetBankingBankRequired =
    paymentRequest.payment_mode === 'netbanking' &&
    isEmpty(getValueFromAppConfig('disableDropDown'));

  const handleSubmit = async () => {
    if (
      paymentRequest.deposited_amount === 0 ||
      paymentRequest.deposited_amount === undefined ||
      paymentRequest.deposited_amount === ''
      // (isNetBankingBankRequired && isEmpty(paymentRequest.selected_bank))
    ) {
      setValidationError(true);
      return false;
    }
    setIsLoading(true);
    const req = {
      pgname: paymentRequest.pgname,
      payment_mode: paymentRequest.payment_mode,
      deposited_amount: paymentRequest.deposited_amount,
      bankid:
        paymentRequest.payment_mode === 'netbanking'
          ? paymentRequest.selected_bank
          : '',
    };
    const res = await acceptReceiptRequest(req);
    if (res && res?.ApiStatus?.Status === 'OK') {
      const { Txid, PgUrl, TotalInvoice, PgCharges, GSTOnPgCharges } =
        res.ApiStatus.Result;
      setTotalInvoice(TotalInvoice);
      setGstOnPgCharges(GSTOnPgCharges);
      setPgCharge(PgCharges);
      setRefTxId(Txid);
      let urlToRedirect = `${PgUrl}?txid=${Txid}`;
      let selectedBank = paymentRequest.selected_bank;
      if (paymentRequest.pgname === 'payu') {
        selectedBank = '';
      }
      if (paymentRequest.payment_mode === 'netbanking') {
        urlToRedirect += `&bankcode=${selectedBank}`;
      }
      urlRef.current = urlToRedirect;
      setOpenConfirmPopup(true);
    } else {
      setAlert({
        variant: 'error',
        title: 'Online Payment',
        description: formattedMessage('failed_to_upload'),
      });
    }
    setIsLoading(false);
  };

  const getPgsForSelectedPaymentMode = (mode) => {
    const list = availablePgsRef.current.filter(
      (x) => x.PaymentMode.toLowerCase() === mode,
    );
    if (list.length > 0) {
      setPaymentRequest((prevState) => ({
        ...prevState,
        pgname: list[0].GatewayName,
      }));
    } else {
      setPaymentRequest((prevState) => ({
        ...prevState,
        pgname: '',
      }));
    }
    setPgOptionsForPaymentMode(list);
  };

  const handleChange = (name, value) => {
    if (name === 'payment_mode') {
      getPgsForSelectedPaymentMode(value);
    }
    setPaymentRequest((prevState) => ({
      ...prevState,
      [name]: value,
      ...(name === 'payment_mode' && value !== 'netbanking'
        ? { selected_bank: '' }
        : {}),
    }));
  };
  const handleProceedToPayment = () => {
    if (urlRef.current !== undefined) {
      const element = document.createElement('a');
      element.href = urlRef.current;
      element.target = '_blank';
      element.click();
      setOpenConfirmPopup(false);
      setOpenStatusPopup(true);
    }
  };

  const handleConfirmPopupClose = () => {
    setOpenConfirmPopup(false);
    setTotalInvoice('');
    setGstOnPgCharges('');
    setPgCharge('');
    setRefTxId('');
    urlRef.current = undefined;
  };
  return (
    <>
      <AccountsPageHorizontalBar selectedPage="online-payment" />
      <section className="balance-upload-page pb-4">
        <AppLoading isLoading={isLoading} />
        {alert && (
          <AppAlert
            showIcon
            variant={alert.variant}
            title={alert.title}
            description={alert.description}
            onHide={() => setAlert(undefined)}
          />
        )}
        <section className="balance-upload-page_container">
          <div className="money-deposit-page_header">Online Payment</div>
          <div className="balance-upload-page_payment-container p-2">
            <Row className="spacing-8">
              <Col lg={3} md={3} sm={6} xs={12}>
                <AppSelect
                  name="payment_mode"
                  id="payment_mode"
                  label={formattedMessage('payment_mode')}
                  placeholder=""
                  isClearable={false}
                  options={PAYMENT_OPTIONS}
                  selectedValue={paymentRequest.payment_mode}
                  onSelect={(data, name) => handleChange(name, data.value)}
                />
              </Col>
              {pgOptionsForPaymentMode.length > 0 && (
                <Col lg={3} md={3} sm={6} xs={12}>
                  <AppSelect
                    name="pgname"
                    id="pgname"
                    label="Payment Gateway"
                    placeholder=""
                    isClearable={false}
                    options={pgOptionsForPaymentMode}
                    selectedValue={paymentRequest.pgname}
                    onSelect={(data, name) => handleChange(name, data.value)}
                  />
                </Col>
              )}
              {isNetBankingBankRequired &&
                getValueFromAppConfig('SELECTBANK') !== 'false' && (
                  <Col lg={3} md={3} sm={6} xs={12}>
                    <AppSelect
                      name="selected_bank"
                      id="selected_bank"
                      label="Select Bank *"
                      placeholder=""
                      isClearable={false}
                      options={NET_BANKING_OPTIONS_LIVE}
                      selectedValue={paymentRequest.selected_bank}
                      onSelect={(data, name) => handleChange(name, data.value)}
                      errorText={validationError && 'Select Bank'}
                    />
                  </Col>
                )}
              <Col lg={3} md={3} sm={6} xs={12}>
                <AppNumberInput
                  name="deposited_amount"
                  id="deposited_amount"
                  label={formattedMessage('deposit_amount')}
                  required
                  placeholderText=""
                  errorText={
                    validationError &&
                    formattedMessage('amount_deposit_validation')
                  }
                  value={paymentRequest.deposited_amount}
                  onChange={(d) => {
                    const cleaned = d.toString().replace(/^0+(?=\d)/, '');
                    if (cleaned === '' || Number(cleaned) === 0) {
                      handleChange('deposited_amount', '');
                      return;
                    }
                    handleChange('deposited_amount', cleaned);
                  }}
                />
                {/* {validationError && (
                  <small className="error-text p-2">
                    {formattedMessage('amount_deposit_validation')}
                  </small>
                )} */}
              </Col>
              <Col
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="d-flex justify-content-end flex-column"
              >
                <div>
                  {paymentRequest.payment_mode !== '' &&
                    paymentRequest.payment_mode !== 'cashcard' &&
                    paymentRequest.pgname === 'payu' && (
                      <div className="d-flex flex-column">
                        <p className="mb-2  fs-14">
                          Accept Terms and Conditions of <b>payu</b>
                        </p>
                        <AppCheckBox
                          labelText={`${agent.Company} certifies that the Credit/Debit Card/Net Banking Account being used for this transaction belongs to ${agent.Company} or an authorized employee of ${agent.Company}. In particular, this Card/Net Banking Account does not belong to a customer or passenger.`}
                          id="payuPgAccepted"
                          name="payuPgAccepted"
                          radioClassName=""
                          checked={isPayuPgAccepted}
                          labelClassName="fs-12"
                          onChange={() => setIsPayuPgAccepted((prev) => !prev)}
                        />
                        <div className="d-flex align-items-center fs-12 ps-sm-4 my-2 ps-2 gap-1">
                          <img
                            src="/images/others/payu.jpg"
                            alt=""
                            height="20px"
                          />
                          <img
                            src="/images/others/visa_mastercard.gif"
                            alt=""
                            height="20px"
                          />
                          <span>
                            (Only Personal Credit Cards @ 1.77% | Rupay Debit
                            Card allowed @0.25%)
                          </span>
                        </div>
                      </div>
                    )}
                </div>
                <div>
                  <AppButton
                    btnText={formattedMessage('submit_btn')}
                    btnType="submit"
                    variant="primary"
                    disabled={
                      paymentRequest.pgname === 'payu' && !isPayuPgAccepted
                    }
                    onClick={handleSubmit}
                  />
                </div>
              </Col>
            </Row>
            {getValueFromAppConfig('TAXSLABIMAGEVAYA') === 'true' && (
              <div className="balance-upload-page_payment-image">
                <img
                  src="/images/others/online_payment_vaya.png"
                  alt="ekcjnksjdc"
                />
                <p className="fs-12">
                  *Cash deposits attract an additional 1% charge. Maximum
                  permitted cash deposit is ₹1,90,000. Any excess amount may be
                  forfeited, and no claim will be accepted.
                </p>
              </div>
            )}
            {getValueFromAppConfig('TAXSLABIMAGE') === 'true' && (
              <div className="balance-upload-page_payment-image">
                <img
                  src={getValueFromAppConfig('TAXSLABIMAGEUPLOAD')}
                  alt="ekcjnksjdc"
                />
              </div>
            )}
          </div>
          {openConfirmPopup && urlRef.current && (
            <Modal
              className="app-modal"
              size="md"
              show={openConfirmPopup}
              onHide={handleConfirmPopupClose}
              backdrop="static"
              keyboard={false}
            >
              <Modal.Header>
                <Modal.Title>
                  {formattedMessage('confirm_payment_for_booking')}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <h5 className="fs-16 fw-600">
                  {appConfig?.isIntlClient === 'true'
                    ? formattedMessage('payment_of_aed')
                    : formattedMessage('payment_of_rupees')}{' '}
                  {totalInvoice} {formattedMessage('will_be_charged')}
                </h5>
                {getValueFromAppConfig('HIDEPGCHARGEINONLIEBOOKING') !==
                  'true' && (
                  <>
                    <p className="fs-14">
                      Pg Charge: {parseFloat(pgCharge).toFixed(2)}
                    </p>
                    {getValueFromAppConfig('HIDEGSTCHARGEINONLIEBOOKING') !==
                      'true' && (
                      <p className="fs-14">
                        GST on Pg Charge:{' '}
                        {parseFloat(gstOnPgCharges).toFixed(2)}
                      </p>
                    )}
                  </>
                )}
              </Modal.Body>
              <Modal.Footer>
                <AppButton
                  btnText={formattedMessage('proceed_btn')}
                  variant="primary"
                  onClick={handleProceedToPayment}
                />
                <AppButton
                  btnText={formattedMessage('cancel')}
                  variant="outlined"
                  onClick={handleConfirmPopupClose}
                />
              </Modal.Footer>
            </Modal>
          )}
          {openStatusPopup && (
            <Modal
              className="app-modal"
              size="md"
              show={openStatusPopup}
              onHide={() => navigate('/')}
              backdrop="static"
              keyboard={false}
            >
              <Modal.Header>
                <Modal.Title>
                  Please confirm the payment for booking
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="d-flex flex-column align-items-center">
                  <p>
                    Check the Booking Status in Transactions page or check the
                    status
                  </p>
                  <AppButton
                    btnText="Show Status"
                    variant="primary"
                    onClick={() => navigate(`/top-up-receipt/${refTxid}`)}
                  />
                </div>
              </Modal.Body>
              <Modal.Footer>
                <AppButton
                  btnText={formattedMessage('cancel')}
                  variant="outlined"
                  onClick={() => navigate('/')}
                />
              </Modal.Footer>
            </Modal>
          )}
        </section>
      </section>
    </>
  );
}

export default BalanceUpload;
